var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('app-snackbar'),_c('router-view'),(_vm.support && _vm.support.mode === 'EMAIL')?_c('support-popup',{style:(_vm.supportStyle),attrs:{"email":_vm.support.email}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }